import {createContext, useContext} from 'react';

/**
 * Context that holds the Contentful `ProductDetail` component data.
 *
 * Written by the `ProductDetail` Contentful model component, which receives
 * the full Contentful entry (including `customizeContent` and
 * `customizeImageBackground`) via its `component` prop after the lazy-fetch
 * completes.
 *
 * Any descendant — e.g. `ChooseYourSets` — can call
 * `useProductDetailContentful()` to access these fields without prop drilling
 * through `ProductDetailComponent`.
 *
 * Returns `null` when used outside the provider (graceful fallback).
 *
 * @type {React.Context<Contentful.ProductDetail | null>}
 */
export const ProductDetailContentfulContext = createContext(null);

/**
 * Hook to access the Contentful ProductDetail component data.
 *
 * @returns {Contentful.ProductDetail | null}
 */
export function useProductDetailContentful() {
  return useContext(ProductDetailContentfulContext);
}
